import { Column } from '@shared/components/table/models/table.models'
import { DEFAULT_STICKY_ROW_STYLE } from '@shared/components/table/constants/table.constants'
import { MatchState } from '@mediacoach/ui'

export const RANKINGS_FEATURE_TOKEN = 'rankings'

export const RANKING_TEAM_COLUMNS: Column[] = [
  {
    key: 'rank',
    styleClass: 'mcm-ranking-container__content-header first-column',
    label: 'MTR_TITLE_POSITION_SHORT',
    width: '80px'
  },
  {
    key: 'name',
    styleClass: 'mcm-ranking-container__content-header',
    label: 'MTR_TITLE_TEAM'
  }
]

export const RANKING_PLAYER_COLUMNS: Column[] = [
  {
    key: 'rank',
    styleClass: 'mcm-ranking-container__content-header first-column',
    label: 'MTR_TITLE_POSITION_SHORT',
    width: '50px'
  },
  {
    key: 'name',
    styleClass: 'mcm-ranking-container__content-header',
    label: 'MTR_TITLE_PLAYER',
    width: 'minmax(85px, 1fr)'
  },
  {
    key: 'teamPhotoUrl',
    styleClass: 'mcm-ranking-container__content-header centered',
    label: 'MTR_TITLE_TEAM',
    width: '50px'
  },
  {
    key: 'position',
    styleClass: 'mcm-ranking-container__content-header',
    label: 'MTR_TITLE_POSITION',
    width: 'minmax(75px, 200px)'
  }
]

export const RANKING_MATCH_PREVIOUS_STATES = [
  MatchState.Pending,
  MatchState.Delayed,
  MatchState.LineupReady,
  MatchState.Postponed
]

export const RANKING_ROW_STYLES: Partial<CSSStyleDeclaration> = {
  ...DEFAULT_STICKY_ROW_STYLE,
  background: 'transparent',
  boxShadow: 'none'
}
